module.exports = __webpack_public_path__ + "res/Roboto-Black-webfont.woff?bdb983ec71be0451649537d45d7d54e2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Black-webfont.woff
// module id = 83
// module chunks = 0